import Config from "./../../config";

const initialState = {
    isDev: false,
    breadcrumbs: [
        {
            id: "home",
            title: "Home",
            url: "/",
        },
        {
            id: "leader-board",
            title: "Leaderboard",
            url: Config.getBaseBreadCrumbUrl(),
        },
    ],
    activeSection: "",
    version: null,
    wasLoggedIn: false,
};

export default (state = initialState, action) => {
    const {type, payload} = action;

    switch (type) {
        case 'LAYOUT_RESET':
            return initialState;

        case "SET_CURRENT_VERSION":
            return {
                ...state,
                version: Config.version
            };

        case "LAYOUT_SET_SECTION":
            state = {
                ...state,
                activeSection: payload
            };
            return state;

        case 'SET_DEV_VIEW_ON':
            return {
                ...state,
                isDev: true
            };

        case 'SET_DEV_VIEW_OFF':
            return {
                ...state,
                isDev: false
            };

        case 'LAYOUT_LOGGED_IN':
            return {
                ...state,
                wasLoggedIn: true
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/layout.js